import { backdropUrl, posterUrl } from "../api/images";
import { yearOf, formatRating, formatRuntime, genreNames, formatDate } from "../lib/format";
import { useWatchlist, toggleWatchlist, watchlistItemFromCard, isInWatchlist } from "../storage/watchlist";
import DownloadButton from "./DownloadButton";

export default function DetailHero({ media, playAction, extraMeta, children }) {
  const list = useWatchlist();
  const backdrop = backdropUrl(media.backdropPath, { hero: true });
  const poster = posterUrl(media.posterPath, { large: true });
  const inList = isInWatchlist(media.contentType, media.tmdbId);

  const meta = [
    yearOf(media.releaseDate || media.firstAirDate),
    media.runtimeMinutes != null && formatRuntime(media.runtimeMinutes),
    media.rating > 0 && `★ ${formatRating(media.rating)}`,
    genreNames(media.genres),
  ].filter(Boolean);

  return (
    <section className="detail-hero">
      {backdrop && <img className="hero-backdrop" src={backdrop} alt="" />}
      <div className="hero-scrim" />
      <div className="detail-content">
        {poster && <img className="detail-poster" src={poster} alt="" />}
        <div className="detail-info">
          <h1 className="hero-title">{media.title}</h1>
          <p className="hero-meta">{meta.join("  ·  ")}</p>
          {extraMeta}
          {media.overview && <p className="hero-overview">{media.overview}</p>}
          <div className="hero-actions">
            {playAction}
            <button
              className={`btn btn-ghost${inList ? " in-list" : ""}`}
              onClick={() =>
                toggleWatchlist(
                  watchlistItemFromCard({
                    contentType: media.contentType,
                    tmdbId: media.tmdbId,
                    title: media.title,
                    overview: media.overview,
                    posterPath: media.posterPath,
                    backdropPath: media.backdropPath,
                    date: media.releaseDate || media.firstAirDate,
                    rating: media.rating,
                  }),
                )
              }
            >
              {inList ? "✓ IN MY LIST" : "+ MY LIST"}
            </button>
            {/* Download next to My List — movies only (episodes come from
                embed hosts; the button itself hides when the title's package
                isn't a browser-downloadable copy). */}
            {media.contentType === "MOVIE" && (
              <DownloadButton type={media.contentType} tmdbId={media.tmdbId} title={media.title} />
            )}
          </div>
          {children}
        </div>
      </div>
    </section>
  );
}